import { sidebarPrimary } from "../routes";
import { isAppEnabled } from "./appAccess";

/**
 * Where `/` should land, given the org's enabled apps. The assistant
 * (Intelligence Hub) is the preferred landing; if it's disabled we fall back
 * down a fixed chain, then to the first enabled primary app, then to the
 * marketplace — so a user is never stranded on a blocked `/`.
 *
 * Fail-open: a null set (unknown enablement) keeps the current behaviour (Hub).
 */
export function resolveDefaultLanding(enabledIds: Set<string> | null): string {
  if (isAppEnabled(enabledIds, "dashboard")) return "/";
  if (isAppEnabled(enabledIds, "homework")) return "/homework";
  if (isAppEnabled(enabledIds, "email")) return "/email";
  const firstEnabled = sidebarPrimary.find((r) => isAppEnabled(enabledIds, r.id));
  return firstEnabled ? firstEnabled.path : "/marketplace";
}
